import React from "react";
import { RouteProps } from "react-router-dom";
import { ConditionPostTypeACF, PopulationPostTypeACF } from "../../constants/types/acf";
import { useCurrentRouteData } from "../../services/app-state";
import { ErrorBoundary } from "../organisms/ErrorBoundary";
import { HeroPostTypePage } from "../organisms/HeroPostTypePage";
import { PageFeedback } from "../organisms/PageFeedback";
import { PageWrapper } from "../organisms/PageWrapper";
import { PostTypePageContent } from "../organisms/PostTypePageContent";

const LocalInformationTemplateInner: React.FC<RouteProps> = () => {
    const page = useCurrentRouteData<PopulationPostTypeACF | ConditionPostTypeACF>();

    return (
        <>
            <HeroPostTypePage
                image={page.acf.meta?.hero_image}
                title={<strong>{page.title.rendered}</strong>}
            />
            <PageWrapper>
                <PostTypePageContent page={page} />
                <PageFeedback reviewedDate={page.modified} />
            </PageWrapper>
        </>
    );
};

export const LocalInformationTemplate: React.FC<RouteProps> = props => (
    <ErrorBoundary>
        <LocalInformationTemplateInner {...props} />
    </ErrorBoundary>
);
